import React from 'react';
import { Avatar } from '#components/Elements/EntityAvatar/Avatar';
import LabelledEntityIcon from './LabelledEntityIcon.js';

/**
 * Component that loads and renders an avatar, by default using LabelledEntityIcon
 */
const EntityAvatar = ({
  contact,
  handle,
  counterparty,
  showAddress,
  render = LabelledEntityIcon,
  ...props
}) => (
  <Avatar
    contact={contact}
    handle={handle}
    counterparty={counterparty}
    render={({
      contactIsLoaded,
      isValid,
      isInternal,
      isAnonymous,
      isVerified,
      src,
      displayName,
      initials,
      displayHandle,
      address,
    }) =>
      render({
        contactIsLoaded,
        src,
        initials,
        displayName,
        displayHandle,
        subtitle:
          showAddress && address
            ? address
            : displayHandle === displayName
              ? ''
              : displayHandle,
        isValid,
        isInternal,
        isAnonymous,
        isVerified,
        showAddress,
        address,
        ...props,
      })
    }
  />
);
export default EntityAvatar;
